module.exports = __webpack_public_path__ + "667f4e5246d3bbaaae222e064320e4d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/MilkyChance_logo_transparent.png
// module id = 268
// module chunks = 0